<script>
  export default {
    props: {
      placeholder: {
        type: String,
        required: true,
      },
      icon: {
        type: String,
      },
    },
  };
</script>

<template>
  <label class="searchFilter">
    <iconic :name="icon" class="searchFilter__icon" />
    <input type="text" :placeholder="placeholder" class="searchFilter__input" @input="(event) => $emit('onChange', event)" />
  </label>
</template>

<style lang="scss">
  .searchFilter {
    @include Flex();
    padding: 6px 13px;
    gap: 5px;
    width: 100%;
    border-radius: 22px;
    border: 1px solid rgba(92, 89, 89, 0.25);
    &__input {
      width: 100%;
      border: none;
      background: transparent;
      font-family: "InterDisplay-Regular";
      font-size: 15px;
    }
  }
</style>
